import styled, { css } from 'styled-components';
import Button from 'components/Button';
import { BlockSize } from 'libs/rendering/gltf/config';
import { themes } from 'styles/themes/wikifactoryNew';

const BUTTON_SIZE = BlockSize.constHeight - 9;

export const Group = styled.ul`
  pointer-events: all;
  font-size: ${props =>
    props.theme.font.size[props.size] || props.theme.font.size.medium};
  padding: 0;
  li {
    position: relative;
  }
`;

export const GroupDropdown = styled.div`
  min-width: 180px;
  border: 1px solid ${props => props.theme.color.wfGrey400};
  border-radius: 2px;
  background-color: ${props => props.theme.color.wfGrey50};
  position: absolute;
  top: 0;
  left: ${BUTTON_SIZE}px;

  ${props =>
    props.dropdownDirection === 'top' &&
    `left: 0;
    top: -4px;
    transform: translate(0%, -100%);`}
`;

export const ButtonStyled = styled(Button)`
  width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;
  top: 2px;
  margin: 0 4px;
  color: ${props =>
    props.isDisabled
      ? props.theme.color.wfGrey500
      : props.isActive
      ? props.theme.color.wfBlue
      : props.customColor
      ? props.theme.color.wfWhite
      : props.theme.color.wfBlack};
  position: relative;
  display: ${props => !props.isVisible && 'none'};
  background-color: ${props =>
    props.customColor
      ? props.customColor
      : props.transparent
      ? 'transparent'
      : props.theme.color.wfWhite};
  border: none;
  border-right: 1px solid
    ${props => props.borderRight || props.theme.color.wfGrey200};
  border-radius: 0;
  align-items: center;
  cursor: ${props => (props.isDisabled ? 'not-allowed' : 'pointer')};
  &::before {
    ${props =>
      props.items &&
      css`
        display: inline-block;
        color: ${props.theme.color.wfWhite};
        background-color: ${props.isActive
          ? props.theme.color.wfWhite
          : props.theme.color.primary};
        border-radius: 50%;
        font-size: ${props.theme.font.size.xsmall};
        line-height: ${props.theme.font.size.xsmall};
        font-weight: 100;
        width: ${props.theme.font.size.xsmall};
        height: ${props.theme.font.size.xsmall};
        position: absolute;
        top: ${props.theme.spacing.small};
        right: ${props.theme.spacing.small};
      `}
  }
  ${props =>
    props.hasDropdown &&
    css`
      &::after {
        content: '';
        width: 0;
        height: 0;
        border: 3px solid transparent;
        border-top: 3px solid currentColor;
        position: absolute;
        bottom: -1px;
        right: -1px;
        transform: rotate(-45deg);
      }
    `}
  &:hover {
    background-color: ${props =>
      !props.isDisabled
        ? props.theme.color.primary
        : props.theme.color.wfWhite};
    color: ${props => !props.isDisabled && props.theme.color.wfWhite};
  }
`;

const getCADColor = props => {
  const { isDisabled, theme, isActive, customColor } = props || {};

  if (isDisabled) {
    return theme.color.wfGrey500;
  }

  if (isActive) {
    return theme.color.wfWhite;
  }

  if (customColor) {
    return theme.color.wfBlue;
  }

  return theme.color.wfBlack;
};

export const CADButton = styled(Button)`
  color: ${props => getCADColor(props)};
  position: relative;
  display: ${props => !props.isVisible && 'none'};
  background-color: ${props =>
    props.customColor || props.isActive
      ? themes.color.wfBlue
      : themes.color.wfWhite} !important;
  border: none;
  border-right: 1px solid
    ${props => props.borderRight || props.theme.color.wfGrey200};
  border-radius: 0;
  align-items: center;
  cursor: ${props => (props.isDisabled ? 'not-allowed' : 'pointer')};
  &::before {
    ${props =>
      props.items &&
      css`
        display: inline-block;
        color: ${props.theme.color.wfWhite};
        background-color: ${props.isActive
          ? props.theme.color.wfWhite
          : props.theme.color.primary};
        border-radius: 50%;
        font-size: ${props.theme.font.size.xsmall};
        line-height: ${props.theme.font.size.xsmall};
        font-weight: 100;
        width: ${props.theme.font.size.xsmall};
        height: ${props.theme.font.size.xsmall};
        position: absolute;
        top: ${props.theme.spacing.small};
        right: ${props.theme.spacing.small};
      `}
  }
  ${props =>
    props.hasDropdown &&
    css`
      &::after {
        content: '';
        width: 0;
        height: 0;
        border: 3px solid transparent;
        border-top: 3px solid currentColor;
        position: absolute;
        bottom: -1px;
        right: -1px;
        transform: rotate(-45deg);
      }
    `}
  &:hover {
    background-color: ${themes.color.wfGrey100};
    color: ${themes.color.wfBlack};
  }
`;
